import React from 'react';
import PropTypes from 'prop-types'
import { Fab } from '@material-ui/core';

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        }
    }

    componentDidMount() {
        //  console.warn('listUsers :', this.props.el);
    }
    render() {
        return (
            <div style={{ minWidth: 100, position: 'relative', display: this.props.openMenu === true ? (this.props.elSelectat.id === this.props.e.id ? 'block' : 'none') : 'none' }}  >
                <Fab style={{
                    background: 'transparent',
                    boxShadow: 'none',
                    position: 'absolute',
                    top: -38,
                    right: -10,
                    zIndex: 102,
                    width: 'fit-content'
                }} onClick={() => { this.props.closeMenu(null) }}>
                    <i className='material-icons'>clear</i>
                </Fab>
                <ul className='pm-menu-container' onClose={this.props.closeMenu}>

                    {/* <li onClick={} className="pm-menu-item">None</li> */}
                    {this.props.el.map((s, idx) => {
                        return (
                            <li key={idx} onClick={() => { this.props.closeMenu(s) }} className="pm-menu-item">{s[this.props.text]}</li>

                        )
                    })}
                </ul>
            </div >
        );
    }
}//end class


Menu.propTypes = {
    openMenu: PropTypes.bool,
    e: PropTypes.object,
    anchorEl: PropTypes.bool,
    el: PropTypes.array,
    closeMenu: PropTypes.func,
    elSelectat: PropTypes.object,

}